export default "__VITE_ASSET__FWZdDGfJ__"